import React, {useEffect, useState} from 'react';

function SignupPage() {

  const [showPopup, setShowPopup] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);

  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const extractNumbers = (str) => {
    return str.match(/\d/g)?.map(Number) || [];
  };

  const validatePassword = (password) => {
    let error = '';
    if (password.length < 8) {
      error = 'password must be at least 8 characters long';
    }
    else if (!/[A-Z]/.test(password)) {
      error = 'password must contain at least one uppercase letter';
    }
    else if (!/[a-z]/.test(password)) {
      error = 'password must contain at least one lowercase letter';
    }
    else if (!/[0-9]/.test(password)) {
      error = 'password must contain at least one number';
    }
    else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      error = 'password must contain at least one special character';
    }
    else if (extractNumbers(password).reduce((acc, num) => acc + num, 0) !== 21) {
      error = 'password must contain numbers that add up to 21';
    }
    else if (extractNumbers(password).reduce((acc, num) => acc * num, 1) < 336) {
      error = 'password must contain numbers that multiply to more than 336';
    }
    else if (extractNumbers(password).length !== 3) {
      error = 'password must contain exactly three numbers';
    }
    else if (isNaN(password[0])) {
      error = 'password must start with a number';
    }
    else if (password[0] === '6' || password[0] === '8') {
      error = 'password must not start with 6 or 8';
    }
    return error;
  }

  const handleChange = (e) => {
    const newPassword = e.target.value;
      setPassword(newPassword);
      setPasswordError(validatePassword(newPassword));
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      if (!passwordError) {
        setShowSignupPopup(true);
        console.log('Password is valid:', password);
            
      } else {
        console.log('Password validation failed.');
      }
    };

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen pb-20">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg p-8 w-full max-w-md pt-10">
        <form onSubmit={handleSubmit}>
          <h1 className="text-xl font-semibold text-center">Signup Page</h1>

          <h2 className="text-lg font-medium py-2">Email</h2>
          <input type="email" className="border border-gray-300 rounded-md p-2 w-full text-black" placeholder="something@example.com" required />

          <h2 className="text-lg font-medium py-2">Password</h2>
          <input type="text" value={password} onChange={handleChange} className="border border-gray-300 rounded-md p-2 w-full text-black" placeholder="good luck" required />
          
          {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
          
          <button type="submit" className="bg-blue-500 text-white rounded-md p-2 w-full mt-2">
            Signup
          </button>

          <p className="text-center text-gray-600 mt-2">Already have an account? {" "}
            <span className="text-center text-blue-500 cursor-pointer" 
            onClick={() => setShowPopup(true)}>
              Login
            </span>
          </p>
        </form>

        <div className="items-center justify-between mt-4">
          <p className="text-center text-gray-600"> *Disclaimer: This does not sign you up for anything* </p>
        </div>
      </div>
      
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 dark:bg-gray-800 rounded-lg shadow-lg p-6 max-w-sm text-center text-white">
            <p>Nuh uh</p>
            <br></br>
            <p>Go and signup - good luck with the password</p>
            <button
              className="mt-4 bg-blue-500 rounded-md px-4 py-2"
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {showSignupPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 dark:bg-gray-800 rounded-lg shadow-lg p-6 max-w-sm text-center text-white">
            <p>Thanks for playing along!</p>
            <button className="mt-4 bg-blue-500 rounded-md px-4 py-2" onClick={() => setShowSignupPopup(false)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
}

export default SignupPage; 